import React from 'react';
import PropTypes from 'prop-types';
import { Title } from '@nerdwallet/currency';
import Row from '../row/row';
import AppButtons from '../app-buttons/app-buttons';

import { stringInputSpec } from '../../lib/editing-configs';

import './app-row.less';

/*
 * Row container for native app links.
 */
const AppRow = ({ appStoreURL, backgroundColor, googlePlayURL, title }) => (
  <Row className="app-row" backgroundColor={backgroundColor}>
    <Row centeredInParent standardMaxWidths>
      <Title
        className="app-row-title"
        component="h3"
        size="small"
        align="center"
      >
        {title}
      </Title>
      <AppButtons
        className="app-row__text-me-container"
        appStoreURL={appStoreURL}
        googlePlayURL={googlePlayURL}
      />
    </Row>
  </Row>
);

AppRow.propTypes = {
  backgroundColor: PropTypes.string,
  title: PropTypes.string,
  appStoreURL: PropTypes.string,
  googlePlayURL: PropTypes.string,
};

AppRow.getEditingConfig = () => [
  stringInputSpec('title', 'Section title'),
  ...AppButtons.getEditingConfig(),
];

AppRow.displayName = 'AppRow';

export default AppRow;
